/**
 * File: useTimerState.ts
 * Path: apps/admin/src/shared/hooks/useTimerState.ts
 * Description: The running timer shared across the admin: the context the
 * TimerProvider fills and the useTimer hook that start buttons read.
 */

import { createContext, useContext } from "react";
import type { EffortRecord } from "../services/effortService";
import type { RunningTimer } from "../utils/timerUtils";

export interface TimerApi {
  running: RunningTimer | null;
  /** Starts a timer; one at a time, so a second start says which is running. */
  start: (record: EffortRecord) => void;
}

/** Outside the provider (a page rendered on its own) starting a timer does nothing. */
export const TimerContext = createContext<TimerApi>({ running: null, start: () => undefined });

export const useTimer = (): TimerApi => useContext(TimerContext);
